import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { statusTone } from '../../../components/ui/StatusBadge';
import { formatRelative, sameText } from '../../../utils/format';
import { useRecentSessions } from '../hooks/useHomeLists';

const SessionRow = ({ session }) => {
  const title = session.title || session.originalFilename || 'Untitled session';
  const meta = [
    sameText(session.eventTitle, title) ? null : session.eventTitle,
    session.userName,
    formatRelative(session.updatedAt || session.createdAt, ''),
  ].filter(Boolean);
  return (
    <Link to={`/sessions/${session.id}`} className="home-activity-row">
      <div className={`home-act-dot home-status-${statusTone(session.status)}`} />
      <div className="home-act-body">
        <div className="home-act-title">{title}</div>
        <div className="home-act-meta">{meta.join(' · ')}</div>
      </div>
    </Link>
  );
};

export default function RecentSessions() {
  const [sessions, loading, error] = useRecentSessions();
  return (
    <section>
      <div className="home-section-head">
        <h2>Recent sessions</h2>
        <Link to="/sessions">View all <ArrowRightIcon /></Link>
      </div>
      <div className="home-card">
        {loading ? (
          <div className="home-empty-row"><div className="home-spinner" />Loading…</div>
        ) : error || sessions.length === 0 ? (
          <div className="home-empty-row">{error || 'No sessions yet.'}</div>
        ) : sessions.map((session) => <SessionRow key={session.id} session={session} />)}
      </div>
    </section>
  );
}
